<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>
<div *ngIf="taskOptionsService.selectedBoard">
    <div class="row" style="margin-left: 5px">
        <div style="max-width: 75px">
            <i (click)="isShowIcons = !isShowIcons" *ngIf="!taskOptionsService.selectedBoard.icon"
               data-action='openIcons'
               style="cursor: pointer; width: 200px;">{{ 'MODALS.FIELDS.SELECT.ICON_NOT_SELECTED' | translate }}</i>
            <i (click)="taskOptionsService.selectedBoard.icon = ''" *ngIf="taskOptionsService.selectedBoard.icon"
               class="bi bi-trash float-end"
               data-action='deleteIcon'
               style="color: red; cursor: pointer; margin-left: 60px;"></i><br>
            <i (click)="isShowIcons = !isShowIcons"
               *ngIf="taskOptionsService.selectedBoard.icon" class="{{taskOptionsService.selectedBoard.icon}}"
               style="font-size: 3em; cursor: pointer; width: 50px; height: 50px;"></i>

            <div *ngIf="isShowIcons" class="iconsTable table2">
                <i (click)="taskOptionsService.selectedBoard.icon = icon; isShowIcons = false;"
                   *ngFor="let icon of icons.all"
                   [attr.data-icon]="icon" class="{{icon}}" data-action='setIcon'
                   style="margin: 5px; cursor: pointer; font-size: 2em;">
                </i>
            </div>
            <div (click)="isShowIcons = false" *ngIf="isShowIcons" class="overflow open" style="background: none"></div>
        </div>
        <div class="col">
            <div>
                <label class="form-label">{{ 'MODALS.FIELDS.ALIAS' | translate }}
                    : {{ taskOptionsService.selectedBoard.alias }}</label>
            </div>
            <div class="mb-2 mt-2">
                <label class="form-label" style="margin-right: 5px">{{ 'MODALS.FIELDS.TITLE' | translate }}:</label>
                <input #boardName
                       (change)="taskOptionsService.selectedBoard.name = boardName.value"
                       [value]="taskOptionsService.selectedBoard.name"
                       class="form-control small-input"
                       type="text"
                >
            </div>
            <div class="flex-display">
                <span style="margin-right: 5px">{{ 'MODALS.FIELDS.GROUP' | translate }}: </span>
                <span *ngIf="!editGroup && this.taskOptionsService.selectedBoard.group_id"> {{ taskOptionsService.groupSelectedBoard.title }}
                    <i></i></span>
                <i (click)="editGroup = true"
                   *ngIf="!editGroup && !this.taskOptionsService.selectedBoard.group_id">{{ 'MODALS.FIELDS.SELECT.NOT_SELECTED' | translate }}</i>
                <i (click)="editGroup = true" *ngIf="!editGroup" class="bi bi-pen active-icon"></i>
                <i (click)="editGroupSelectedBoard(null)"
                   *ngIf="!editGroup && this.taskOptionsService.selectedBoard.group_id"
                   class="bi bi-trash text-danger active-icon"></i>

                <select #groupId (change)="editGroupSelectedBoard(groupId.value)" *ngIf="editGroup"
                        class="form-select" style="width: 400px; padding: 5px">
                    <option [selected]="!this.taskOptionsService.selectedBoard.group_id" hidden=""
                            value="">{{ 'MODALS.FIELDS.SELECT.GROUP' | translate }}
                    </option>
                    <option *ngFor="let group of taskOptionsService.boardsGroups"
                            [selected]="this.taskOptionsService.selectedBoard.group_id && group.id === taskOptionsService.groupSelectedBoard.id"
                            [value]="group.id">{{ group.title }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <h2>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}:</h2>
    <app-component-ckeditor
            (emitFinish)="taskOptionsService.selectedBoard.description = $event[1]"
            [inputData]="taskOptionsService.description"
            [isShowButtons]="false">
    </app-component-ckeditor>

    <div style="margin-top: 20px;">
        <button (click)="saveDashboard()" [disabled]="isLockButton" class="btn btn-success"
                data-action='saveSettings'><span
                *ngIf="!isLockButton else refresh">{{ 'BUTTON_TEXT.SAVE' | translate }}</span></button>
    </div>
</div>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
